<template>
  <div>

    <div class="container m-b-1-sm m-b-1-md m-t-2-md">
      <h1 class="titulo m-y-1-md">Base de datos</h1>
      <a
        class="btn btn-descarga boton-simplificado"
        :href="`${cdn_archivos_dominio}/enis/salud/vih/vih_red_completa-clusters_vih-notas_metodologica-tabla_relacion.zip`"
        download="vih_red_completa-clusters_vih-notas_metodologica-tabla_relacion"
      >
      <span class="titulo-link">
        Archivo de descarga
        </span>
        <br />
        <small>
          El zip contiene los datos de los conglomerados y red VIH, notas metodológicas, tabla de relación, así como seis archivos vectoriales en formato GeoPackage (gpkg) con sus tablas correspondientes en formato csv, xlsx y metadatos en formato txt.
        </small>
        <span class="icono icon-archivo-descargar"></span>
      </a>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Datos",
  components: {
  },
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
    };
  },
  computed: {
    ...mapState(["numero_nodos_clusters", "nodos_totales", "cdn_archivos_dominio"]),
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-responsivo {
  border-radius: 10px;
  border: 1px solid #333;
  overflow: hidden;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.titulo-centrado {
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    text-align: center;
  }
}
.btn-descarga {
  display: block;
  border-radius: $gap * 0.5;
  width: 100%;
  padding: $gap $gap * 3 $gap $gap;
  position: relative;
  .icono {
    position: absolute;
    right: $gap;
    top: calc(50% - 15px);
    background: transparent;
    color: #fff;
    width: 30px;
    height: 30px;
    // border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
  }
}

.fondo-azul-claro {
  background-color: #e1f2ff;
  padding-top: 30px;
}
</style>
